import { render } from "./NavParcAuto.vue?vue&type=template&id=63ac3893"
import script from "./NavParcAuto.vue?vue&type=script&lang=js"
export * from "./NavParcAuto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__